// src/App.js

import React, { useState } from "react";
import { ContentProvider } from "./ContentContext";
import { Header, Footer, BackToTop, MobileBar } from "./components/Chrome";
import { ColdChain } from "./components/Effects";
import { Hero, Installations, Process, Why, Sectors } from "./components/Sections";
import Gallery from "./components/Gallery";
import ClientLogos from "./components/ClientLogos";
import SizingTool from "./components/SizingTool";
import EnquiryForm from "./components/EnquiryForm";

export default function App() {
  // Set by the sizing tool, consumed once by the enquiry form. Held here
  // rather than in a context because it is one value passed between two
  // siblings.
  const [brief, setBrief] = useState(null);

  return (
    <ContentProvider>
      <Header />
      <ColdChain />
      <main>
        <Hero />
        <Installations />
        <Process />
        <SizingTool onUseBrief={setBrief} />
        <Gallery />
        <Why />
        <ClientLogos />
        <Sectors />
        <EnquiryForm brief={brief} />
      </main>
      <Footer />
      <BackToTop />
      <MobileBar />
    </ContentProvider>
  );
}